<template>
  <!-- <lu-vbox>
    <lu-scroll-area style='height: 250px;margin-right:20px;'>
    <lu-vbox v-if='data.length > 0'  class='inst-container'>
      <lu-hbox class='vpad-in-5 rowData' style='' v-for='(ins, index) in data' :key='ins.instrumentName' v-if='index < count'>
        <lu-item lu-flex class='rowTitle'>{{ ins.label }}</lu-item>
        <lu-item :class='ins.exposure >= 0  ? "positive" : "negative"'>{{ ins.exposure | formatAmount }}</lu-item>
        < ! - - <lu-item :class='ins.profitAndLoss >= 0  ? "positive" : "negative"'>{{ ins.profitAndLoss | formatAmount }}</lu-item> - - >
        <lu-item>{{ ins.vwap | formatRate(6) }}</lu-item>
        <lu-item>{{ ins.best | formatRate(5) }}</lu-item>
      </lu-hbox>
    </lu-vbox>
    <lu-item v-else style='justify-content:center;'>No data</lu-item>
    </lu-scroll-area>
   </lu-vbox> -->
    <div  :style='{width: panelWidth}' >
      <!--
    <table width='100%' class='table' v-if='data && data.length'>
      <tr>
        <th width='30%' class='colTitle'>{{ $t(label) }}</th>
        <th width='20%' class='colTitle'>{{ $t("P&L") }}</th>
        <th width='25%' v-if='isSymbolGrpKey' class='colTitle'>{{ $t("VWAP") }}</th>
        <th width='25%' v-if='isSymbolGrpKey' class='colTitle'>{{ $t("Current") }}</th>
      </tr>
      <tr class='lu-click' v-for='(ins, index) in data' :key='ins.instrumentName' v-if='index < count' @dblclick='getDetail(ins.label)'>
        <td lu-flex class='rowTitle'>{{ ins.label }}</td>
        <td class='rowData' :class='ins.exposure >= 0  ? "positive" : "negative"'>{{ ins.exposure | formatAmount }}</td>
        <td class='rowData' v-if='isSymbolGrpKey'>{{ ins.vwap | formatRate(6) }}</td>
        <td class='rowData' v-if='isSymbolGrpKey'>{{ ins.best | formatRate(5) }}</td>
      </tr>
    </table>
    -->
    <el-table
      class='riskTable'
      :data="data"
      :cell-class-name = "() => 'lu-click'"
      :height="panelHeight"
      fit
      style="width: 100%;"
      :row-class-name="tableRowClassName"
      @row-dblclick='row => getDetail(row.label)'
    >
      <el-table-column :label="$t(label)" sortable prop='label' align="left" />
      <el-table-column :label="$t('P&L')" sortable prop='exposure' :sort-method='(a,b) => sortFloat(a,b,"exposure")' align="left">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.exposure >= 0  ? "positive" : "negative"'>{{ scope.row.exposure | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('VWAP')" sortable prop='vwap' :sort-method='(a,b) => sortFloat(a,b,"vwap")' align="center" v-if='isSymbolGrpKey' >
        <template slot-scope="scope">
          <div style='text-align: right'>{{ scope.row.vwap | formatRate(6) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Current')" sortable prop='best' :sort-method='(a,b) => sortFloat(a,b,"best")' align="center" v-if='isSymbolGrpKey' >
        <template slot-scope="scope">
          <div style='text-align: right'>{{ scope.row.best | formatRate(5) }}</div>
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
// import { LuVbox, LuHbox, LuItem, LuScrollArea } from 'lusis-ui'
import utils from '@/utils/formatNumber'
import { mapState } from 'vuex'
import monitoringMixin from './mixins'

export default {
  name: 'InstrPnlArray',
  props: [ 'data', 'label', 'panel' ],
  mixins: [ monitoringMixin ],
  // components: {LuScrollArea, LuHbox, LuVbox, LuItem},
  computed: {
    ...mapState({ groupKeys: state => state.settingsMonitor.settingParams.changeGrouping }),
    isSymbolGrpKey: function () {
      return this.groupKeys[this.panel.options.groupKey] === "symbol"
    }
  },
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value, 2, 3)
    },
    formatRate: function (value, prec) {
      return utils.formatNumber(value || 0, prec)
    }
  },
  methods: {
    getDetail: function (label) {
      let curLabel = this.isSymbolGrpKey ? 'Symbol' : 'Currency'
      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': curLabel, 'paramValue': label}
      ]
      // this.$store.dispatch('settingsMonitor/changeDetailParams', {title: this.panel.options.title, type: curLabel.toLowerCase(), value: label, params: params, show: true})
      this.$emit('getDetail', {title: this.panel.options.title, type: curLabel.toLowerCase(), value: label, params: params, show: true})
    }
  }
}
</script>

<style lang='scss' scoped>
.inst-container {
  .rowData {
    justify-content: center;
    vertical-align: baseline;
    height: 25px;
    margin: 5px 0;
  }
}
</style>